/* NOTE: AUTO GENERATED FILE! Do not modify directly! */

import * as React from 'react';
import { ReactComponent as ArrowDown } from '../../../assets/svg/square-button-icons/arrow-down-18.svg';
import { ReactComponent as Checkmark } from '../../../assets/svg/square-button-icons/checkmark-18.svg';
import { ReactComponent as Close } from '../../../assets/svg/square-button-icons/close-20.svg';
import { ReactComponent as CloseSmall } from '../../../assets/svg/square-button-icons/close-16.svg';
import { ReactComponent as Discover } from '../../../assets/svg/square-button-icons/discover-18.svg';
import { ReactComponent as Dots } from '../../../assets/svg/square-button-icons/dots-18.svg';
import { ReactComponent as DotsShifted } from '../../../assets/svg/square-button-icons/dots-18.svg';
import { ReactComponent as Edit } from '../../../assets/svg/square-button-icons/edit-24.svg';
import { ReactComponent as Hamburger } from '../../../assets/svg/square-button-icons/hamburger-26-20.svg';
import { ReactComponent as Help } from '../../../assets/svg/square-button-icons/help-24.svg';
import { ReactComponent as Hide } from '../../../assets/svg/square-button-icons/eye-disable-18.svg';
import { ReactComponent as Notification } from '../../../assets/svg/square-button-icons/bell-24.svg';
import { ReactComponent as Plus } from '../../../assets/svg/square-button-icons/plus-18.svg';
import { ReactComponent as Settings } from '../../../assets/svg/square-button-icons/settings-24.svg';
import { ReactComponent as Show } from '../../../assets/svg/square-button-icons/eye-18.svg';
import { ReactComponent as Download } from '../../../assets/svg/square-button-icons/download-20.svg';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';

type IconPropsType = {
  name: SquareButtonIconsEnum;
};

export const SquareButtonIcon = (props: IconPropsType): JSX.Element => {
  switch (props.name) {
    case SquareButtonIconsEnum['arrowDown']:
      return <ArrowDown />;
    case SquareButtonIconsEnum['checkmark']:
      return <Checkmark />;
    case SquareButtonIconsEnum['close']:
      return <Close />;
    case SquareButtonIconsEnum['closeSmall']:
      return <CloseSmall />;
    case SquareButtonIconsEnum['discover']:
      return <Discover />;
    case SquareButtonIconsEnum['dots']:
      return <Dots />;
    case SquareButtonIconsEnum['dotsShifted']:
      return <DotsShifted />;
    case SquareButtonIconsEnum['edit']:
      return <Edit />;
    case SquareButtonIconsEnum['hamburger']:
      return <Hamburger />;
    case SquareButtonIconsEnum['help']:
      return <Help />;
    case SquareButtonIconsEnum['hide']:
      return <Hide />;
    case SquareButtonIconsEnum['notification']:
      return <Notification />;
    case SquareButtonIconsEnum['plus']:
      return <Plus />;
    case SquareButtonIconsEnum['settings']:
      return <Settings />;
    case SquareButtonIconsEnum['show']:
      return <Show />;
    case SquareButtonIconsEnum['download']:
      return <Download />;
    default:
      return <span>No Content!</span>;
  }
};
